import type { FunctionComponent } from "react";
import { TimeAgo } from "@kanda-libs/ks-design-library";
import { CLASS_NAMES } from "components/job/JobTable/CreatedAt/constants";
import useCreatedAtProps from "components/job/JobTable/CreatedAt/useCreatedAtProps";

export interface CreatedAtProps {
  date: string;
}

export const CreatedAt: FunctionComponent<CreatedAtProps> = (props) => {
  const { timestamp } =
    useCreatedAtProps(props);

  return (
    <div className="flex flex-col">
      <p className={CLASS_NAMES.label}>
        <span>Created</span> <TimeAgo timestamp={timestamp} />
      </p>
    </div>
  );
};
